import React, { useEffect, useState } from 'react';
import { qantasHotels } from 'roo-ui/logos';
import { rem } from 'polished';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Container, Flex, Link } from 'roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';
import { QCOM_LANDING_PAGE_URL } from 'config';
import PhoneMenu from 'components/PhoneMenu';
import QffMenu from 'components/QffMenu';
import { fixBodyScroll, unfixBodyScroll } from 'lib/browser';
import LoginTooltip from 'components/LoginTooltip';

const qantasLogoClip = '71px';

const Logo = styled.img`
  display: inline-flex;
  clip-path: inset(0 0 -1px ${qantasLogoClip});
  margin-left: -${qantasLogoClip};
  ${mediaQuery.minWidth.md} {
    width: ${rem('186px')};
  }
`;

const HeaderInner = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  padding-left: ${themeGet('space.4')};
  border-bottom: 1px solid ${themeGet('colors.greys.porcelain')};
`;

const HeaderPhone = () => {
  const [isPhoneMenuOpen, setIsPhoneMenuOpen] = useState(false);
  const [isQffMenuOpen, setIsQffMenuOpen] = useState(false);

  useEffect(() => {
    const isOpen = isPhoneMenuOpen || isQffMenuOpen;

    isOpen ? fixBodyScroll() : unfixBodyScroll();

    return () => {
      unfixBodyScroll();
    };
  }, [isPhoneMenuOpen, isQffMenuOpen]);

  return (
    <Container p={0}>
      <HeaderInner>
        <Flex alignItems="center">
          <Link href={QCOM_LANDING_PAGE_URL} mr={4} p={1} data-testid="qh-logo-link">
            <Logo src={qantasHotels} alt="Qantas" role="img" aria-label="Qantas Logo" />
          </Link>
        </Flex>
        <Flex data-print-style="hidden">
          <PhoneMenu isPhoneMenuOpen={isPhoneMenuOpen} setIsPhoneMenuOpen={setIsPhoneMenuOpen} setIsQffMenuOpen={setIsQffMenuOpen} />
          <QffMenu isQffMenuOpen={isQffMenuOpen} setIsQffMenuOpen={setIsQffMenuOpen} setIsPhoneMenuOpen={setIsPhoneMenuOpen} />
        </Flex>
      </HeaderInner>
      <LoginTooltip isPhone />
    </Container>
  );
};

export default HeaderPhone;
